import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// صلاحية التخزين المؤقت (ساعة واحدة)
const CACHE_TTL = 60 * 60 * 1000;

// دالة لجلب الفيديوهات من YouTube API
export const getYouTubeVideos = createAsyncThunk(
    'youtube/getVideos',
    async (channelId, { rejectWithValue }) => {
        try {
            const cacheKey = `youtube_${channelId}`;
            const cachedData = localStorage.getItem(cacheKey);

            // إذا كانت البيانات مخزنة ولم تنته صلاحيتها، نستخدمها
            if (cachedData) {
                const { timestamp, data } = JSON.parse(cachedData);
                if (Date.now() - timestamp < CACHE_TTL) {
                    return data; // إعادة استخدام البيانات المخزنة
                }
            }

            // إذا لم تكن البيانات مخزنة أو انتهت صلاحيتها، نجري طلبًا جديدًا
            const API_KEY = 'AIzaSyCeOFR3ZicZkKwVgfKEIgZrEF8O2rd6Lxc';
            const response = await axios.get(
                `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${channelId}&maxResults=10&order=date&type=video&key=${API_KEY}`
            );

            // الحصول على تفاصيل الفيديوهات (مثل المدة)
            const videoIds = response.data.items.map((item) => item.id.videoId).join(',');
            const detailsResponse = await axios.get(
                `https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=${videoIds}&key=${API_KEY}`
            );

            // دمج البيانات
            const videos = response.data.items.map((item, index) => ({
                ...item,
                duration: detailsResponse.data.items[index].contentDetails.duration,
            }));

            // حفظ النتائج في localStorage مع الطابع الزمني
            localStorage.setItem(cacheKey, JSON.stringify({
                timestamp: Date.now(),
                data: videos,
            }));

            return videos;
        } catch (error) {
            return rejectWithValue(error.response?.data?.error?.message || 'حدث خطأ ما');
        }
    }
);

// إنشاء slice باستخدام Redux Toolkit
const youtubeSlice = createSlice({
    name: 'youtube',
    initialState: {
        videos: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getYouTubeVideos.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getYouTubeVideos.fulfilled, (state, action) => {
                state.loading = false;
                state.videos = action.payload;
            })
            .addCase(getYouTubeVideos.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

// تصدير الـ reducer
export default youtubeSlice.reducer;